import React from "react";
import { Button } from "@deliverr/ui";
import { ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { CustomsScanModal } from "./CustomsScanModal";

export const MasterCartonNotFoundModal: React.FC = () => {
  const { hideModal } = useSortationModal();

  return (
    <ModalTemplate
      title={
        <FormattedMessage
          id="sortation.customsScan.masterCartonNotFoundModal.title"
          defaultMessage="Master Carton Not Found"
        />
      }
      text={
        <FormattedMessage
          id="sortation.customsScan.masterCartonNotFoundModal.body"
          defaultMessage={"The scanned master carton was not found. Please contact a supervisor for assistance. "}
        />
      }
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
    >
      <Button block onClick={() => hideModal(CustomsScanModal.MASTER_CARTON_NOT_FOUND)}>
        <FormattedMessage id="sortation.customsScan.masterCartonNotFoundModal.continue" defaultMessage="Continue" />
      </Button>
    </ModalTemplate>
  );
};
